import { render, staticRenderFns } from "./ModalDialogGetToken.vue?vue&type=template&id=1906b480&scoped=true&"
import script from "./ModalDialogGetToken.vue?vue&type=script&lang=js&"
export * from "./ModalDialogGetToken.vue?vue&type=script&lang=js&"
import style0 from "./ModalDialogGetToken.vue?vue&type=style&index=0&id=1906b480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1906b480",
  null
  
)

export default component.exports